import React from 'react';
import { Box, Pagination, Typography } from '@mui/material';

interface JiraPaginationProps {
  offset: number;
  limit: number;
  total: number;
  onChange: (offset: number) => void;
}

const JiraPagination: React.FC<JiraPaginationProps> = ({ offset, limit, total, onChange }) => {
  const currentPage = Math.floor(offset / limit) + 1;
  const totalPages = Math.ceil(total / limit);

  const handlePageChange = (_event: React.ChangeEvent<unknown>, page: number) => {
    const newOffset = (page - 1) * limit;
    onChange(newOffset);
  };

  if (total === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 3 }}>
      <Typography variant="body2" color="text.secondary">
        Показано {Math.min(offset + 1, total)} - {Math.min(offset + limit, total)} из {total}
      </Typography>
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={handlePageChange}
        color="primary"
      />
    </Box>
  );
};

export default JiraPagination;
